import { parsePhoneNumberFromString, type CountryCode } from "libphonenumber-js"

export function normalizeMetaLeadPhoneNumber(
  value: string,
  defaultCountry: CountryCode,
): string | null {
  const parsed = parsePhoneNumberFromString(value.trim(), defaultCountry)
  if (!parsed?.isValid()) return null
  return parsed.number
}

export function normalizeMetaTestPhoneNumber(value: string): string | null {
  const trimmedValue = value.trim()
  if (!trimmedValue.startsWith("+")) return null
  const parsed = parsePhoneNumberFromString(trimmedValue)
  if (!parsed?.isValid()) return null
  return parsed.number
}
